import React from "react";
import { Module } from "../../../modules/academy/models";

export interface ModuleCardProps {
  module: Module;
  microCoursesDone: number;
  microCoursesTotal: number;
  progressionPercent: number;
  isCompleted: boolean;
  isKid?: boolean;
  onOpenModule?: (moduleId: string) => void;
}

export function ModuleCard({
  module,
  microCoursesDone,
  microCoursesTotal,
  progressionPercent,
  isCompleted,
  isKid,
  onOpenModule,
}: ModuleCardProps) {
  const { id, title, description, microCourseIds, audience, level } = module;
  return (
    <div className="mm-surface p-4 space-y-2">
      <h3 className="text-base font-semibold">{title}</h3>
      {!isKid && description && (
        <p className="text-sm text-slate-600 dark:text-slate-300">{description}</p>
      )}
      <div className="flex items-center justify-between text-xs text-slate-500 dark:text-slate-400 flex-wrap gap-2">
        <span>{microCourseIds?.length ? `${microCourseIds.length} micro-cours` : "Micro-cours a venir"}</span>
        <span>{level}</span>
        <span>{audience}</span>
        <span>{isKid ? `${microCoursesDone}/${microCoursesTotal}` : `${progressionPercent}%`}</span>
      </div>
      {isCompleted && (
        <span className="text-[11px] inline-flex px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-600 border border-emerald-500/30">
          Module complete
        </span>
      )}
      <button
        type="button"
        className="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
        onClick={() => onOpenModule?.(id)}
      >
        Ouvrir le module
      </button>
    </div>
  );
}
